function headingText(raw) {
  return String(raw)
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\*([^*]+)\*/g, "$1")
    .replace(/---/g, "—")
    .trim();
}

function slugify(text) {
  const slug = headingText(text)
    .toLowerCase()
    .replace(/[^\w\u4e00-\u9fff-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return slug || "section";
}

export function extractHeadings(source) {
  const items = [];
  const used = {};
  String(source)
    .replace(/\r\n/g, "\n")
    .split("\n")
    .forEach((line) => {
      const match = line.match(/^(#{2,3})\s+(.*)$/);
      if (!match) return;
      const text = headingText(match[2]);
      let id = slugify(text);
      if (used[id]) {
        used[id] += 1;
        id = `${id}-${used[id]}`;
      } else {
        used[id] = 1;
      }
      items.push({ id, text, level: match[1].length });
    });
  return items;
}
